import { render, staticRenderFns } from "./distributionAbnormal.vue?vue&type=template&id=157d9c00&scoped=true&"
import script from "./distributionAbnormal.vue?vue&type=script&lang=js&"
export * from "./distributionAbnormal.vue?vue&type=script&lang=js&"
import style0 from "./distributionAbnormal.vue?vue&type=style&index=0&id=157d9c00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157d9c00",
  null
  
)

export default component.exports